module.exports = __webpack_public_path__ + "img/Skirt-Front-B10-Cc-Ha.e35eb04f.png";